import { Box, Typography, darken } from '@mui/material'
import ReportPage, {
  ReportPageModelName
} from 'components/templates/ReportPage'
import colors from 'styles/colors'
import InCardStack from 'components/atoms/container/InCardStack'
import RadarGraph from 'components/molecules/assessments/RadarGraph'
import { useTranslation } from 'react-i18next'
import RowStack from 'components/atoms/container/RowStack'
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule'

const Legend = ({ color, label }) => (
  <RowStack width='unset' spacing={2}>
    <RowStack spacing={0} width='unset'>
      <Box
        width={8}
        height={8}
        borderRadius={4}
        sx={{ backgroundColor: color }}
      />
      <HorizontalRuleIcon sx={{ color, fontSize: 12, marginLeft: -2 }} />
    </RowStack>
    <Typography sx={{ color }} variant='body1Micro'>
      {label}
    </Typography>
  </RowStack>
)

const CategorySummaryPage = ({
  downloadingFile,
  goalData,
  categoryData,
  pageNum
}) => {
  const { t } = useTranslation()
  const categoryColor = categoryData?.color || colors.Black
  const darkCategoryColor = darken(categoryColor, 0.2) || colors.Black
  const behaviorBenchmarks = {}
  categoryData.data.behaviourInfoData.forEach(
    d => (behaviorBenchmarks[d.name] = d.benchmarkScore)
  )
  const radarChartData = {
    ...categoryData.data.radarChartData,
    others: behaviorBenchmarks
  }
  const assessmentData = { goalData, ...categoryData.data, radarChartData }

  return (
    <>
      <ReportPage
        assessmentName={goalData?.name}
        downloadingFile={downloadingFile}
        pageNum={pageNum}
        childrenWrapperSx={{ paddingLeft: 26, paddingRight: 26 }}>
        <InCardStack>
          <ReportPageModelName
            modelName={categoryData?.modelName}
            color={categoryColor}
          />

          <Typography variant='reportH1' sx={{ color: darkCategoryColor }}>
            {categoryData?.name} {t('fullReport.summary')}
          </Typography>

          <RadarGraph
            assessmentData={assessmentData}
            disableBehaviorClick={true}
            size={350}
            labelColor={darkCategoryColor}
            disableScroll={true}
          />
          <RowStack width='unset' spacing={16}>
            <Legend
              color={colors.Teal400}
              label={t('fullReport.overallScore')}
            />
            <Legend color={colors.Grey350} label={t('fullReport.benchmark')} />
          </RowStack>
          <Typography
            variant='formText'
            style={{
              color: colors.MidnightTeal400,
              width: '80%',
              marginTop: 60
            }}>
            {categoryData?.description}
          </Typography>
          <Typography
            variant='body1Micro'
            fontStyle='italic'
            color={colors.Grey350}
            style={{ width: '80%' }}>
            {t('fullReport.benchmarkDescription')}
          </Typography>
        </InCardStack>
      </ReportPage>
    </>
  )
}

export default CategorySummaryPage
